module.exports = __webpack_public_path__ + "static/media/flower-tulip.79c244fa.svg";